<div id="window__container"
  class="app-window tw-h-full tw-flex tw-flex-col"
     [style.height]="isIframeMode ? 'auto' : (isDesktopView ? '100dvh' : 'auto')"
     [style.display]="portalSportsbookService.portalDisplay()">
  <app-window-header></app-window-header>
  @if (isDesktopView) {
    @defer (on immediate) {
      <app-window-desktop></app-window-desktop>
    }
  } @else {
    @defer (on immediate) {
      <app-window-mobile></app-window-mobile>
    }
  }
</div>
